module.exports = __webpack_public_path__ + "assets/icon-trashcan-component.56d8318a.svg";